// extracted by mini-css-extract-plugin
module.exports = {"actions":"TransferSuccess_actions__16npE","back-link-button":"TransferSuccess_back-link-button__243_j"};